import React, { useEffect, useRef, useState } from 'react'
import { MousePointerClick } from 'lucide-react'
import { HubPreview } from './HubPreview'

const PREVIEW_MAX_WIDTH = 400

export function phoneHeightFor(screenWidth) {
  return Math.round((852 * screenWidth) / 393) + 12
}

export function ProductPreview({ sport, screenWidth = 288, maxFrameHeight }) {
  const [width, setWidth] = useState(0)
  const boxRef = useRef(null)
  const height = maxFrameHeight ? Math.min(phoneHeightFor(screenWidth), maxFrameHeight) : phoneHeightFor(screenWidth)

  useEffect(() => {
    const node = boxRef.current
    if (!node || typeof ResizeObserver === 'undefined') return undefined
    const observer = new ResizeObserver(([entry]) => setWidth(Math.round(entry.contentRect.width)))
    observer.observe(node)
    return () => observer.disconnect()
  }, [])

  const previewWidth = Math.min(width || PREVIEW_MAX_WIDTH, PREVIEW_MAX_WIDTH)

  return (
    <figure ref={boxRef} className="m-0 flex w-full flex-col items-center">
      <p className="mb-3 text-center text-[13px] font-semibold text-[#57534e]">Your game page</p>
      <HubPreview sport={sport} width={previewWidth} height={height} />
      <figcaption className="mt-3 flex items-center justify-center gap-2 rounded-full bg-[#14B8A6]/10 px-3.5 py-2 text-[13px] text-[#0f3f3a]">
        <MousePointerClick aria-hidden className="h-4 w-4 shrink-0 text-[#0d9488]" />
        <span>
          <span className="font-semibold">Try it:</span> switch tabs to see the video and every player&apos;s stats.
        </span>
      </figcaption>
    </figure>
  )
}
